var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { DiagramBase } from '../basics/DiagramBase';
import { setOrDef, setIfDef } from "../Helpers";
var SimpleDiagramBase = /** @class */ (function (_super) {
    __extends(SimpleDiagramBase, _super);
    function SimpleDiagramBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setPadding = function (padding) {
            return padding ? [
                setOrDef(padding, function (x) { return x.top; }, 0),
                setOrDef(padding, function (x) { return x.right; }, 0),
                setOrDef(padding, function (x) { return x.bottom; }, 0),
                setOrDef(padding, function (x) { return x.left; }, 0),
            ]
                : undefined;
        };
        _this.setAxisData = function (dia, axis, additional) {
            var toRet = __assign({ name: setOrDef(axis, function (x) { return x.name; }, ""), nameLocation: 'center', nameGap: 25, nameTextStyle: {
                    fontStyle: 'italic'
                }, show: axis && axis.show, min: axis && axis.autoRange && axis.minValue !== undefined ? axis.minValue : undefined, max: axis && axis.autoRange && axis.maxValue !== undefined ? axis.maxValue : undefined, boundaryGap: dia.type === "Line" ? false : true, axisLabel: {
                    show: setOrDef(axis, function (x) { return setOrDef(x.label, function (y) { return y.show; }, true); }, true),
                    rotate: setOrDef(axis, function (x) { return x.tickRotation; }, 0),
                    fontSize: setIfDef(axis, function (x) { return setIfDef(x.label, function (y) { return y.fontSize; }); }),
                    color: setIfDef(axis, function (x) { return setIfDef(x.label, function (y) { return y.color; }); }),
                    formatter: setIfDef(axis, function (x) { return setIfDef(x.label, function (y) { return _this.getLabelFormatter(y); }); }),
                    margin: setOrDef(axis, function (x) { return setOrDef(x.label, function (y) { return y.margin; }, 8); }, 8),
                    padding: axis && axis.label && _this.setPadding(axis.label.padding)
                } }, additional);
            if (axis && axis.hideTick)
                toRet.axisTick = { show: false };
            if (axis && axis.hideLine)
                toRet.axisLine = { show: false };
            return toRet;
        };
        _this.getBaseOption = function () {
            var d = _this.props.diagram;
            var dd = _this.props.diagram;
            var features = {};
            if (d.legend && d.legend.show) {
                if (d.legend.showDownload) {
                    features.saveAsImage = {
                        show: true,
                        type: 'png'
                    };
                    features.restore = { show: d.legend.showMagic ? true : false };
                }
                if (d.legend.showMagic)
                    features.magicType = {
                        show: d.legend.showMagic ? true : false,
                        type: ['line', 'bar', 'stack', 'tiled']
                    };
                if (d.legend.showZoom)
                    features.dataZoom = {
                        show: true,
                    };
            }
            var opt = {
                toolbox: {
                    bottom: -5,
                    right: 0,
                    showTitle: false,
                    orient: 'horizontal',
                    feature: features
                },
                legend: d.legend && d.legend.show ? {
                    show: true,
                    orient: setOrDef(d.legend, function (x) { return x.direction; }, 'vertical'),
                    align: setOrDef(d.legend, function (x) { return x.itemAlign; }, 'auto'),
                    left: setOrDef(d.legend, function (x) { return x.horizontalAlignment; }, 'right'),
                    top: setOrDef(d.legend, function (x) { return x.verticalAlignment; }, 'top'),
                    padding: d.legend ? _this.setPadding(d.legend.padding) : undefined,
                    textStyle: { color: setOrDef(d.legend, function (x) { return x.fontColor; }, '#000000') }
                } : { show: false },
                xAxis: _this.setAxisData(d, d.axisX, {
                    type: !d.axisX || !d.axisX.type ? (dd.swapAxis === true ? 'value' : 'category') : d.axisX.type,
                    data: d.axisX && d.axisX.type === "time" ? undefined : (_this.state.data.keys && _this.state.data.keys.length > 0 ? _this.state.data.keys[0].names : [])
                }),
                yAxis: _this.setAxisData(d, d.axisY, {
                    type: dd.swapAxis === true ? 'category' : 'value',
                    data: dd.swapAxis === true && _this.state.data.keys && _this.state.data.keys.length > 0 ? _this.state.data.keys[0].names : undefined
                }),
            };
            return opt;
        };
        _this.setupMinAndMax = function () {
            if (!_this.props.diagram.maxColor && !_this.props.diagram.minColor || !_this.props.diagram.groupBy || _this.props.diagram.groupBy.length < 1 || !_this.state.data)
                return;
            var pMax = {};
            var pMin = {};
            pMax[_this.props.diagram.groupBy[0]] = _this.state.data.maxVals[0];
            pMin[_this.props.diagram.groupBy[0]] = _this.state.data.minVals[0];
            _this.colorNode(pMax, _this.props.diagram.maxColor);
            _this.colorNode(pMin, _this.props.diagram.minColor);
        };
        _this.colorNode = function (name, color) {
            if (!color)
                return;
            var node = _this.findDataElement(name);
            if (node && node[0])
                node[0].itemStyle = { color: color };
        };
        _this.findDataElement = function (path) {
            if (Object.keys(path).length > 2 || _this.state.data === undefined || _this.state.data.keys === undefined || _this.state.data.keys.length === 0)
                return undefined;
            var keys = _this.state.data.keys;
            if (!keys)
                return undefined;
            var i = (typeof path[keys[0].key] === "number") ? path[keys[0].key] : _.findIndex(keys[0].names, function (v) { return v === path[keys[0].key]; });
            var j = keys.length > 1 ? _.findIndex(keys[1].names, function (v) { return v === path[keys[1].key]; }) : 0;
            var series = _this.state.data.data.series;
            if (keys.length < series.length) {
                var toRet = void 0;
                for (j = 0; j < series.length; j++) {
                    if (i >= 0 && j >= 0) {
                        if (series[j].data[i]) {
                            if (!toRet)
                                toRet = [];
                            toRet.push(series[j].data[i]);
                        }
                    }
                }
                return toRet;
            }
            else if (i >= 0 && j >= 0) {
                if (series[j].data[i])
                    return [series[j].data[i]];
                else
                    return undefined;
            }
            return undefined;
        };
        _this.onClick = function (data) {
            _this.redraw();
            _super.prototype.onClick.call(_this, data);
        };
        return _this;
    }
    SimpleDiagramBase.prototype.needRecalc = function (nextProps) {
        var res = _super.prototype.needRecalc.call(this, nextProps);
        var ndp = nextProps.diagram;
        var dp = this.props.diagram;
        res = res || (dp ? dp.stacked : false) !== (ndp ? ndp.stacked : false);
        res = res || (!_.isEqual(dp.area, ndp.area));
        return res;
    };
    return SimpleDiagramBase;
}(DiagramBase));
export default SimpleDiagramBase;
//# sourceMappingURL=SimpleDiagramBase.js.map